import React, {
  ReactNode,
  createContext,
  useContext,
  useState,
} from "react";

interface ApiContextType {
  isLockAnalyzeButton: boolean;
  setLockAnalyzeButton: React.Dispatch<React.SetStateAction<boolean>>;
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export const useAnalysisContext = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error("useApiContext must be used within an ApiProvider");
  }
  return context;
};
interface AnalysisContextProps {
  children: ReactNode;
}
export const AnalysisContext: React.FC<AnalysisContextProps> = ({
  children,
}) => {
  const [isLockAnalyzeButton, setLockAnalyzeButton] = useState<boolean>(false);
  return (
    <ApiContext.Provider
      value={{
        isLockAnalyzeButton,
        setLockAnalyzeButton,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};
